import { useMemo } from 'react';

import { useCareStateDomain } from '@/entities/care-state-domain';
import {
  selectEnrichedActiveActions,
  type EnrichedActiveProposedAction,
} from '@/entities/proposed-actions';

export type EnrichedProposedAction = EnrichedActiveProposedAction;

/**
 * Returns every active proposed action for the current patient, enriched
 * with dependency + visibility metadata. Must be called exactly once per
 * render of the requests workspace tab (see `RequestsListTab`) — downstream
 * components receive the resulting `items` array as a prop rather than
 * re-invoking this hook.
 */
export function useProposedActionsPlan() {
  const { careState } = useCareStateDomain();
  const allActions = useMemo(() => careState?.proposed_actions ?? [], [careState]);
  const enriched = useMemo<EnrichedProposedAction[]>(
    () => selectEnrichedActiveActions(allActions),
    [allActions]
  );

  return {
    actions: enriched,
    isEmpty: enriched.length === 0,
    isLoading: careState === null,
  };
}
